export default __webpack_public_path__ + "static/media/PaquetePrecio.fc5651c1.svg";